<template>
    <div>
        <b-button v-if="!isIcon" @click="showPaymentModal" style="font-size: 0.675rem" class="mt-2" size="sm" :variant="'primary'">
            Payment Details
        </b-button>
        <b-button v-else 
            @click="showPaymentModal" 
            size="sm" 
            variant="outline-primary" 
            class="mr-1 btn-action"
            v-b-tooltip.hover title="Payment Summary"
        >
            <i :class="iconClass || 'fa fa-money'"></i>
        </b-button>


        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="paymentsModal" hide-footer
            :title="'Payment Details-#' + JobAssNo">
            <b-row v-if="getJobData"> <b-col md="4" class="mt-2"><strong>Client Name : </strong>{{
                getJobData.getJob.ClientName
                    }}</b-col>
                <b-col md="4" class="mt-2"><strong>Exp Client Name : </strong>{{
                    getJobData.getJob.ExpClientName }}</b-col>
                <b-col md="4" class="mt-2"><strong>Imp Client Name : </strong>{{
                    getJobData.getJob.ImpClientName }}</b-col>
                <b-col md="4" class="mt-2"><strong>Sline Name : </strong>{{
                    getJobData.getJob.SlineName
                }}</b-col>
            </b-row>
            <b-row v-if="getJobData">
                <b-col cols="12">
                    <b-tabs>
                        <b-tab title="Job Details" :active="activeTab === 'jobDetails'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-card>
                                        <b-card-text>
                                            <b-row>
                                                <b-col md="4" class="mt-2"><strong>Enq No : </strong>{{
                                                    getJobData.getJob.EnqNo
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Enq Date : </strong>{{
                                                    getJobData.getJob.EnqDate }}</b-col>

                                                <b-col md="4" class="mt-2"
                                                    v-if="getJobData.getJob.getSubscription && (getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Subscription
                                                        ID :
                                                    </strong>{{ getJobData.getJob.getSubscription.id
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="getJobData.getJob.getSubscription && (getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Subscription
                                                        Status
                                                        : </strong>{{
                                                            getJobData.getJob.getSubscription.subscription_status_detials_status
                                                                == "1" ? "Subscribed" : "Failed"
                                                        }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="getJobData.getJob.getSubscription && (getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Booking
                                                        Type :
                                                    </strong>{{
                                                        getJobData.getJob.getSubscription.bookingType }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="getJobData.getJob.getSubscription && (getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Contract
                                                        No :
                                                    </strong>{{
                                                        getJobData.getJob.getSubscription.contract_no }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="getJobData.getJob.getSubscription && (getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Booking
                                                        For :
                                                    </strong>{{
                                                        getJobData.getJob.getSubscription.booking_for }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="getJobData.getJob.getSubscription && (getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Booking
                                                        No :
                                                    </strong>{{
                                                        getJobData.getJob.getSubscription.booking_no }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="getJobData.getJob.getSubscription && (getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>BRF
                                                        No :
                                                    </strong>{{
                                                        getJobData.getJob.getSubscription.enquiry_booking_no }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="getJobData.getJob.getSubscription && (getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Enq
                                                        Price No :
                                                    </strong>{{
                                                        getJobData.getJob.getSubscription.enquiry_no }}</b-col>

                                                <b-col md="4" class="mt-2"><strong>Job Type : </strong>{{
                                                    getJobData.getJob.JobType }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Transport Type : </strong>{{
                                                    getJobData.getJob.JobTransportType }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Job No : </strong>{{
                                                    getJobData.getJob.JobNo
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Job Date : </strong>{{
                                                    getJobData.getJob.JobDate
                                                    }}</b-col>

                                                <b-col md="4" class="mt-2"><strong>Client Name : </strong>{{
                                                    getJobData.getJob.ClientName
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Exp Client Name : </strong>{{
                                                    getJobData.getJob.ExpClientName }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Imp Client Name : </strong>{{
                                                    getJobData.getJob.ImpClientName }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Sline Name : </strong>{{
                                                    getJobData.getJob.SlineName
                                                    }}</b-col>

                                                <b-col md="4" class="mt-2"
                                                    v-if="(getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>SOB :
                                                    </strong>{{
                                                        getJobData.getJob.SOB }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="(getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Vessel
                                                        Voyage : </strong>{{
                                                            getJobData.getJob.VesselVoyage }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>ETA Estimated : </strong>{{
                                                    getJobData.getJob.ETAEstimated }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="(getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>ETA
                                                        Actual : </strong>{{
                                                            getJobData.getJob.ETAActual }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>MBL : </strong>{{
                                                    getJobData.getJob.MBL }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>MBL Date : </strong>{{
                                                    getJobData.getJob.MBLDate }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>MBL Release Date : </strong>{{
                                                    getJobData.getJob.MBLReleaseDate }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>HBL : </strong>{{
                                                    getJobData.getJob.HBL }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>POR : </strong>{{
                                                    getJobData.getJob.POR }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>POL : </strong>{{
                                                    getJobData.getJob.POL }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>POD : </strong>{{
                                                    getJobData.getJob.POD }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>FPOD : </strong>{{
                                                    getJobData.getJob.FPOD
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>PICK : </strong>{{
                                                    getJobData.getJob.PICK
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>HAND : </strong>{{
                                                    getJobData.getJob.HAND
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>STUFF : </strong>{{
                                                    getJobData.getJob.STUFF
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Raised From : </strong>{{
                                                    getJobData.getJob.RaisedFrom
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Raised By : </strong>{{
                                                    getJobData.getJob.RaisedBy
                                                    }}</b-col>

                                                <b-col md="4" class="mt-2"><strong>Total Income : </strong>{{
                                                    getJobData.getJob.totPLIncomes
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Total Expense : </strong>{{
                                                    getJobData.getJob.totPLExpenses
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Total Profit/Loss : </strong>{{
                                                    getJobData.getJob.totPLProfit
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2">
                                                    <strong>P/L Status : </strong>
                                                    <b-badge
                                                        :variant="getJobData.getJob._rowVariant ? getJobData.getJob._rowVariant : (getJobData.getJob.totPLLabel === 'Loss' ? 'danger' : getJobData.getJob.totPLLabel === 'Profit' ? 'success' : 'secondary')"
                                                    >
                                                        {{ getJobData.getJob.totPLLabel || "Normal" }}
                                                    </b-badge>
                                                </b-col>

                                                <b-col md="4" class="mt-2"><strong>Container Type : </strong>{{
                                                    getJobData.getJob.JobTContainerType }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Containers : </strong>{{
                                                    getJobData.getJob.Containers
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"><strong>Checking By : </strong>{{
                                                    getJobData.getJob.LoginUserName
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="(getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Risk :
                                                    </strong>{{
                                                        getJobData.getJob.sub_noti_risk
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="(getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Risk
                                                        Desc : </strong>{{
                                                            getJobData.getJob.sub_noti_risk_description
                                                        }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="(getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Risk
                                                        Conclusion : </strong>{{
                                                            getJobData.getJob.sub_noti_conclusion
                                                        }}</b-col>
                                                <b-col md="4" class="mt-2"
                                                    v-if="(getJobData.getJob.JobType.indexOf('FF') >= 0)"><strong>Risk
                                                        Event MSG : </strong>{{
                                                            getJobData.getJob.sub_noti_event_message
                                                        }}</b-col>

                                            </b-row>
                                        </b-card-text>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="BRF Details" :active="activeTab === 'brfDetails'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-card v-if="getJobData.getJob.BrfData">
                                        <b-card-text>
                                            <b-row>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.BrfNo"><strong>BRF No : </strong>{{
                                                    getJobData.getJob.BrfData.BrfNo
                                                    }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.BrfEnqNo"><strong>Brf Enq No : </strong>{{
                                                    getJobData.getJob.BrfData.BrfEnqNo }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.BookingNo"><strong>Booking No : </strong>{{
                                                    getJobData.getJob.BrfData.BookingNo }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.BookingType"><strong>Booking Type : </strong>{{
                                                    getJobData.getJob.BrfData.BookingType }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.BookingFor"><strong>Booking For : </strong>{{
                                                    getJobData.getJob.BrfData.BookingFor }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.RecordType"><strong>Record Type : </strong>{{
                                                    getJobData.getJob.BrfData.RecordType }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.SpotNonSpot"><strong>Spot/NonSpot : </strong>{{
                                                    getJobData.getJob.BrfData.SpotNonSpot }}</b-col>
                                                
                                                <b-col md="12"><hr></b-col>

                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.TransportType"><strong>Transport Type : </strong>{{
                                                    getJobData.getJob.BrfData.TransportType }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.ShipmentType"><strong>Shipment Type : </strong>{{
                                                    getJobData.getJob.BrfData.ShipmentType }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.DeliveryMode"><strong>Delivery Mode : </strong>{{
                                                    getJobData.getJob.BrfData.DeliveryMode }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.IncoTerm"><strong>Inco Term : </strong>{{
                                                    getJobData.getJob.BrfData.IncoTerm }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.FirstMileBooking"><strong>First Mile Booking : </strong>{{
                                                    getJobData.getJob.BrfData.FirstMileBooking }}</b-col>

                                                <b-col md="12"><hr></b-col>

                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.POR"><strong>POR : </strong>{{
                                                    getJobData.getJob.BrfData.POR }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.POL"><strong>POL : </strong>{{
                                                    getJobData.getJob.BrfData.POL }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.POD"><strong>POD : </strong>{{
                                                    getJobData.getJob.BrfData.POD }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.FPOD"><strong>FPOD : </strong>{{
                                                    getJobData.getJob.BrfData.FPOD }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.EmptyPick"><strong>Empty Pick : </strong>{{
                                                    getJobData.getJob.BrfData.EmptyPick }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.RaisedFrom"><strong>Raised From : </strong>{{
                                                    getJobData.getJob.BrfData.RaisedFrom }}</b-col>

                                                <b-col md="12"><hr></b-col>

                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.ContainerType"><strong>Container Type : </strong>{{
                                                    getJobData.getJob.BrfData.ContainerType }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.CommodityType"><strong>Commodity Type : </strong>{{
                                                    getJobData.getJob.BrfData.CommodityType }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.CommodityName"><strong>Commodity Name : </strong>{{
                                                    getJobData.getJob.BrfData.CommodityName }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.OtherCommodity"><strong>Other Commodity : </strong>{{
                                                    getJobData.getJob.BrfData.OtherCommodity }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.CargoWeight"><strong>Cargo Weight : </strong>{{
                                                    getJobData.getJob.BrfData.CargoWeight }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.PackingCode"><strong>Packing Code : </strong>{{
                                                    getJobData.getJob.BrfData.PackingCode }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.ImdgClass"><strong>Imdg Class : </strong>{{
                                                    getJobData.getJob.BrfData.ImdgClass }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.UNNumber"><strong>UN Number : </strong>{{
                                                    getJobData.getJob.BrfData.UNNumber }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.TemperatureRequired"><strong>Temperature : </strong>{{
                                                    getJobData.getJob.BrfData.TemperatureRequired }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.Humidity"><strong>Humidity : </strong>{{
                                                    getJobData.getJob.BrfData.Humidity }}</b-col>

                                                <b-col md="12"><hr></b-col>

                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.ETD"><strong>ETD : </strong>{{
                                                    getJobData.getJob.BrfData.ETD }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.ValidTill"><strong>Valid Till : </strong>{{
                                                    getJobData.getJob.BrfData.ValidTill }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.ValidForSail"><strong>Valid For Sail : </strong>{{
                                                    getJobData.getJob.BrfData.ValidForSail }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.SiCutOfDate"><strong>SI Cut Off : </strong>{{
                                                    getJobData.getJob.BrfData.SiCutOfDate }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.HandoverDate"><strong>Handover Date : </strong>{{
                                                    getJobData.getJob.BrfData.HandoverDate }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.QuotationTill"><strong>Quotation Till : </strong>{{
                                                    getJobData.getJob.BrfData.QuotationTill }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.TemplateValidTill"><strong>Template Valid Till : </strong>{{
                                                    getJobData.getJob.BrfData.TemplateValidTill }}</b-col>

                                                <b-col md="12"><hr></b-col>

                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.CurrencyName"><strong>Currency : </strong>{{
                                                    getJobData.getJob.BrfData.CurrencyName }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.currencyCode"><strong>Currency Code : </strong>{{
                                                    getJobData.getJob.BrfData.currencyCode }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.FreightTermsMbl"><strong>Freight Terms MBL : </strong>{{
                                                    getJobData.getJob.BrfData.FreightTermsMbl }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.FreightTermsHbl"><strong>Freight Terms HBL : </strong>{{
                                                    getJobData.getJob.BrfData.FreightTermsHbl }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.DestinationCharges"><strong>Dest. Charges : </strong>{{
                                                    getJobData.getJob.BrfData.DestinationCharges }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.ContractNo"><strong>Contract No : </strong>{{
                                                    getJobData.getJob.BrfData.ContractNo }}</b-col>

                                                <b-col md="12"><hr></b-col>

                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.ClientName"><strong>Client : </strong>{{
                                                    getJobData.getJob.BrfData.ClientName }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.SalesPerson"><strong>Sales Person : </strong>{{
                                                    getJobData.getJob.BrfData.SalesPerson }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.BookingRaisedBy"><strong>Raised By : </strong>{{
                                                    getJobData.getJob.BrfData.BookingRaisedBy }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.AgentHandlingExpense"><strong>Agent Handling Exp : </strong>{{
                                                    getJobData.getJob.BrfData.AgentHandlingExpense }}</b-col>
                                                
                                                <b-col md="12"><hr></b-col>

                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.Remarks"><strong>Remarks : </strong>{{
                                                    getJobData.getJob.BrfData.Remarks }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.BLInstruction"><strong>BL Instruction : </strong>{{
                                                    getJobData.getJob.BrfData.BLInstruction }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.PDA"><strong>PDA : </strong>{{
                                                    getJobData.getJob.BrfData.PDA }}</b-col>
                                                <b-col md="4" class="mt-2" v-if="getJobData.getJob.BrfData.FreeDays"><strong>Free Days : </strong>{{
                                                    getJobData.getJob.BrfData.FreeDays }}</b-col>
                                            </b-row>
                                            <b-row v-if="getJobData.getJob.BrfData.PricingList && getJobData.getJob.BrfData.PricingList.length > 0" class="mt-3">
                                                <b-col cols="12">
                                                    <h6>Pricing List</h6>
                                                    <b-table 
                                                        show-empty 
                                                        stacked="md" 
                                                        :items="getJobData.getJob.BrfData.PricingList"
                                                        :fields="pricingFields"
                                                        small
                                                    >
                                                    </b-table>
                                                </b-col>
                                            </b-row>
                                        </b-card-text>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Note" :active="activeTab === 'credit_note'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.CRDRList"
                                        :fields="crdrFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                            <b-button style="margin-left: 2px; font-size: 0.675rem" size="sm"
                                                variant="warning" class="mb-1" v-if="row0.item.fullDocumentLink != ''"
                                                @click="viewDoc(row0.item.fullDocumentLink)">View</b-button>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Expense" :active="activeTab === 'expense'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.ExpenseList"
                                        :fields="expenseFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                            <b-button style="margin-left: 2px; font-size: 0.675rem" size="sm"
                                                variant="warning" class="mb-1" v-if="row0.item.fullDocumentLink != ''"
                                                @click="viewDoc(row0.item.fullDocumentLink)">View</b-button>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Additional Task" :active="activeTab === 'additionalTask'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.AdditionalTaskList"
                                        :fields="additionalTaskFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Sline" :active="activeTab === 'sline'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.SlineList"
                                        :fields="SlineFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                        </template>
                                        <template slot="slineBlNo" slot-scope="row1">
                                            <span>Bl No : {{ row1.item.slineBlNo }}</span><br />
                                            <span>Due Date : {{ row1.item.dueDate }}</span><br />
                                            <span>SOB : {{ row1.item.sobDate }}</span><br />
                                            <span>SC Category : {{ row1.item.scCategory }}</span><br />
                                            <span>SC Remark : {{ row1.item.scremark }}</span><br />
                                        </template>
                                        <template slot="invoiceType" slot-scope="row1">
                                            <span>Inv Type : {{ row1.item.invoiceType }}</span><br />
                                            <span>Inv No : {{ row1.item.invoiceNumber }}</span><br />
                                            <span>Inv Category : {{ row1.item.invoiceCategory }}</span><br />
                                            <span>AMT : {{ row1.item.amount }}</span><br />
                                            <span>Currency : {{ row1.item.currency }}</span><br />
                                        </template>
                                        <template slot="currency" slot-scope="row1">
                                            <span>Pay Mode : {{ row1.item.paymode }}</span><br />
                                            <span>Paid AMT : {{ row1.item.paidAmount }}</span><br />
                                            <span>Pay Date : {{ row1.item.payDate }}</span><br />
                                            <span>Pay Reference : {{ row1.item.payReference }}</span><br />
                                        </template>
                                        <template slot="createdBy" slot-scope="row1">
                                            <span>Created By : {{ row1.item.createdBy }}</span><br />
                                            <span>Created At : {{ row1.item.loginTime }}</span><br />
                                        </template>
                                        <template slot="paymode" slot-scope="row1">
                                            <b-button style="margin-left: 2px; font-size: 0.675rem" size="sm"
                                                variant="warning" class="mb-1" v-if="row1.item.blDraftUpload != ''"
                                                @click="viewDoc(row1.item.blDraftUpload)">View</b-button>
                                        </template>
                                        <template slot="paidAmount" slot-scope="row1">
                                            <b-button style="margin-left: 2px; font-size: 0.675rem" size="sm"
                                                variant="warning" class="mb-1" v-if="row1.item.slineInvoice != ''"
                                                @click="viewDoc(row1.item.slineInvoice)">View</b-button>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Manifestation" :active="activeTab === 'manifestation'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.ManifestationList"
                                        :fields="ManifestFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Containers" :active="activeTab === 'containers'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.ContainerList"
                                        :fields="ContainerFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="GRN List" :active="activeTab === 'grn'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.GRNList"
                                        :fields="GRNFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                            <b-button style="margin-left: 2px; font-size: 0.675rem" size="sm"
                                                variant="warning" class="mb-1" v-if="row0.item.fullDocumentLink != ''"
                                                @click="viewDoc(row0.item.fullDocumentLink)">View</b-button>
                                        </template>
                                        <template slot="tptType" slot-scope="row1">
                                            <span>{{ row1.item.tptType==1?'Pridel':row1.item.tptType==2?'Outsourced':'N/A' }}</span><br />
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Tally Billing" :active="activeTab === 'tallybill'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.TallyList"
                                        :fields="TallyFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Reverse Tally Billing" :active="activeTab === 'revTallybill'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.reverse_tally_billing"
                                        :fields="ReverseTallyFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Reverse Expense" :active="activeTab === 'reverseExp'" class="custom-tab">
                            <b-row>
                                <b-col cols="12">
                                    <b-table show-empty stacked="md" :items="getJobData.getJob.tally_billing_expense"
                                        :fields="ReverseExpenseFields" :per-page="perPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                                        <template slot="SN" slot-scope="row0">
                                            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-col>
                <b-col cols="12" class="text-center">
                    <b-button class="mt-3" variant="outline-danger" style="font-size: 0.675rem"
                        @click="closePaymentModal">Close</b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>

</template>

<script>
import NodeLockPannelService from "../../services/NodeLockPannelService";
export default {
    props: {
        allModuleId: { type: Number, default: null },
        JobNo: { type: String, default: null },
        isIcon: { type: Boolean, default: false },
        iconClass: { type: String, default: '' },
    },
    data() {
        return {
            currentPage: 1,
            perPage: 25,
            sortBy: null,
            sortDesc: false,
            sortDirection: "asc",
            filter: null,
            activeTab: 'jobDetails',
            JobAssNo: this.JobNo,
            JobId: this.allModuleId,
            getJobData: null,
            alert: {
                content: "Added Successfully",
                ok: "ok",
            },
            pricingFields: [
                { key: 'ContainerType', label: 'Container Type' },
                { key: 'TuesCount', label: 'Tues' },
                { key: 'TotalContainer', label: 'Total Containers' },
                { key: 'Currency', label: 'Currency' },
                { key: 'BuyRate', label: 'Buy Rate' },
                { key: 'SellRate', label: 'Sell Rate' },
                { key: 'Remark', label: 'Remark' },
            ],
            expenseFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "nature_of_expense",
                    mainkey: "nature_of_expense",
                    label: "Nature Of Expense",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "documentName",
                    mainkey: "documentName",
                    label: "Name",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "docRemarks",
                    mainkey: "docRemarks",
                    label: "Remarks",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "createdBy",
                    mainkey: "createdBy",
                    label: "Created By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },

                {
                    key: "createdDate",
                    mainkey: "createdDate",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
            crdrFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },

                {
                    key: "note_type",
                    mainkey: "note_type",
                    label: "Inv Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "noteSeries",
                    mainkey: "noteSeries",
                    label: "Inv No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "noteDate",
                    mainkey: "noteDate",
                    label: "Inv Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "noteAmount",
                    mainkey: "noteAmount",
                    label: "Inv Amt",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "agentType",
                    mainkey: "agentType",
                    label: "Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "AgentColoader",
                    mainkey: "AgentColoader",
                    label: "Agent",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "shipper",
                    mainkey: "shipper",
                    label: "Shipper",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "consignee",
                    mainkey: "consignee",
                    label: "Consignee",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "createdBy",
                    mainkey: "createdBy",
                    label: "Created By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },

                {
                    key: "createdDate",
                    mainkey: "createdDate",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
            additionalTaskFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "ledgerName",
                    mainkey: "ledgerName",
                    label: "Ledger Name",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "scCategory",
                    mainkey: "scCategory",
                    label: "SC Category",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "selling_amt",
                    mainkey: "selling_amt",
                    label: "Selling AMT",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "amount",
                    mainkey: "amount",
                    label: "AMT",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "remark",
                    mainkey: "remark",
                    label: "Remark",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "createdBy",
                    mainkey: "createdBy",
                    label: "Created By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "createdDate",
                    mainkey: "createdDate",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
            SlineFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "slineBlNo",
                    mainkey: "slineBlNo",
                    label: "Bl No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "invoiceType",
                    mainkey: "invoiceType",
                    label: "Inv Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },

                {
                    key: "currency",
                    mainkey: "currency",
                    label: "Currency",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },

                {
                    key: "paymode",
                    mainkey: "paymode",
                    label: "BL Draft Doc",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "paidAmount",
                    mainkey: "paidAmount",
                    label: "Inv Doc",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },

                {
                    key: "createdBy",
                    mainkey: "createdBy",
                    label: "Created By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },


            ],
            ManifestFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "type",
                    mainkey: "type",
                    label: "Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "type_of_agent",
                    mainkey: "type_of_agent",
                    label: "Type Of Agent",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "noteType",
                    mainkey: "noteType",
                    label: "Note Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "agent_coloder_txt",
                    mainkey: "agent_coloder_txt",
                    label: "Agent",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "consignee_name",
                    mainkey: "consignee_name",
                    label: "Consignee",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "amount",
                    mainkey: "amount",
                    label: "AMT",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "currency",
                    mainkey: "currency",
                    label: "Currency",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "remark",
                    mainkey: "remark",
                    label: "Remark",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "createdBy",
                    mainkey: "createdBy",
                    label: "Created By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "createdDate",
                    mainkey: "createdDate",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
            ContainerFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "containerType",
                    mainkey: "containerType",
                    label: "Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "containerNo",
                    mainkey: "containerNo",
                    label: "Container No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "netWeight",
                    mainkey: "netWeight",
                    label: "Net Weight",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "grossWeight",
                    mainkey: "grossWeight",
                    label: "Gross Weight",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "tareWeight",
                    mainkey: "tareWeight",
                    label: "Tare Weight",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "measurement",
                    mainkey: "measurement",
                    label: "Measurement",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "weightUnit",
                    mainkey: "weightUnit",
                    label: "Unit",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "packageName",
                    mainkey: "packageName",
                    label: "Package Name",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "LineSealNo",
                    mainkey: "LineSealNo",
                    label: "Line Seal No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "customSealNo",
                    mainkey: "customSealNo",
                    label: "Custom Seal No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "loginTime",
                    mainkey: "loginTime",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
            GRNFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "GRNSeries",
                    mainkey: "GRNSeries",
                    label: "GRN No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "containerNo",
                    mainkey: "containerNo",
                    label: "Container No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "FuelSlipNo",
                    mainkey: "FuelSlipNo",
                    label: "Fuel Slip No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "vehicleType",
                    mainkey: "vehicleType",
                    label: "Vehicle Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "vehicleNo",
                    mainkey: "vehicleNo",
                    label: "Vehicle No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "slineSealNo",
                    mainkey: "slineSealNo",
                    label: "Sline Seal No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "customSealNo",
                    mainkey: "customSealNo",
                    label: "Custom Seal No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "factoryInDate",
                    mainkey: "factoryInDate",
                    label: "FactoryInDate",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "factoryOutDate",
                    mainkey: "factoryOutDate",
                    label: "FactoryOutDate",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "tptType",
                    mainkey: "tptType",
                    label: "Transport By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "outSourceGRNo",
                    mainkey: "outSourceGRNo",
                    label: "OutSource GRNo",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },

                {
                    key: "createdBy",
                    mainkey: "createdBy",
                    label: "Created By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },
                {
                    key: "createdDate",
                    mainkey: "createdDate",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
            ReverseTallyFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "DocDtls_Typ",
                    mainkey: "DocDtls_Typ",
                    label: "Inv Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "DocDtls_No",
                    mainkey: "DocDtls_No",
                    label: "Inv No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "DocDtls_Dt",
                    mainkey: "DocDtls_Dt",
                    label: "Inv Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "ledger_group",
                    mainkey: "ledger_group",
                    label: "Ledger",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "Status",
                    mainkey: "Status",
                    label: "Status",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "SellerDtls_LglNm",
                    mainkey: "SellerDtls_LglNm",
                    label: "Seller",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "BuyerDtls_LglNm",
                    mainkey: "BuyerDtls_LglNm",
                    label: "Buyer",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "ValDtls_TotInvVal",
                    mainkey: "ValDtls_TotInvVal",
                    label: "AMT",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },

                {
                    key: "createdDate",
                    mainkey: "createdDate",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
            ReverseExpenseFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "docDtls_Typ",
                    mainkey: "docDtls_Typ",
                    label: "Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "docDtls_No",
                    mainkey: "docDtls_No",
                    label: "Inv No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "docDtls_Dt",
                    mainkey: "docDtls_Dt",
                    label: "Inv Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "ledger_group",
                    mainkey: "ledger_group",
                    label: "Ledger",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "status",
                    mainkey: "status",
                    label: "Status",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "sellerDtls_LglNm",
                    mainkey: "sellerDtls_LglNm",
                    label: "Seller",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "buyerDtls_LglNm",
                    mainkey: "buyerDtls_LglNm",
                    label: "Buyer",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "valDtls_TotInvVal",
                    mainkey: "valDtls_TotInvVal",
                    label: "AMT",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "createdDate",
                    mainkey: "createdDate",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
            TallyFields: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "BillingSeries",
                    mainkey: "BillingSeries",
                    label: "Inv No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "billingLocationName",
                    mainkey: "billingLocationName",
                    label: "Inv Location",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "jobType",
                    mainkey: "jobType",
                    label: "Job Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "weight",
                    mainkey: "weight",
                    label: "Weight",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "vessel",
                    mainkey: "vessel",
                    label: "Vessel",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "blNo",
                    mainkey: "blNo",
                    label: "BlNo",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "clientName",
                    mainkey: "clientName",
                    label: "Client",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "createdBy",
                    mainkey: "createdBy",
                    label: "Created By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "createdDate",
                    mainkey: "createdDate",
                    label: "Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },

            ],
        };
    },
    methods: {
        viewDoc(URL) {
            window.open(`${URL}`);
        },
        setActiveTab(tab) {
            this.activeTab = tab;
        },
        getJobPaymentDetails() {
            this.getJobData = null;
            if (this.JobId && this.JobId > 0) {
                console.log("Updated Row Data:", this.JobId);
                NodeLockPannelService.verifyContainer({ allModuleId: this.JobId, JobNo: this.JobAssNo })
                    .then(response => {
                        const { data, status, statusText } = response;
                        console.log("Update successful:", data.data);
                        if (data.data.length > 0) {
                            this.getJobData = data.data[0];
                        }
                        this.alert.content = data.message;
                    })
                    .catch(error => {
                        console.error("Update failed:", error);
                    });
            } else {
                console.error("Please fill out all required fields.");
            }
        },
        showPaymentModal() {
            this.getJobPaymentDetails();
            this.$refs["paymentsModal"].show();
        },
        closePaymentModal() {
            this.$refs["paymentsModal"].hide();
        }
    },
};
</script>



// WEBPACK FOOTER //
// jobWisePaymentsDetails.vue?c77c781e